function Shop_catalog_form_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    selectGallery: '.js-select-gallery',
	    containerGallery: '.js-container-gallery'
    };

    this.init = function() {

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$selectGallery = this.$element.find(this.selectors.selectGallery);
	    this.$containerGallery = this.$element.find(this.selectors.containerGallery);

	    this.$selectGallery.on('i4:change', this.$onChangeGallery.bind(this));

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$onChangeGallery();
		}).bind(this));
    };

    this.$onChangeGallery = function() {
	    if (this.$selectGallery.val() === '') {
    		this.$containerGallery.show();
	    } else {
	    	this.$containerGallery.hide();
	    }
    };
}
